import { Divider } from "../HennaMotif";

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="relative overflow-hidden border-t border-line/60 py-20 text-center"
  >
    <div className="mx-auto max-w-2xl px-6">
      <Divider className="mb-10" />
      <p className="font-serif text-5xl tracking-tight text-cream md:text-7xl">
        Nurhan <span className="italic text-gold">&amp;</span> Emre
      </p>
      <p className="mt-6 font-sans text-xs uppercase tracking-[0.35em] text-sand">
        Düğün · 15 Kasım 2026
      </p>
      <p className="mt-2 font-sans text-sm text-sand/70">
        Çekmeköy, İstanbul
      </p>
      <p className="mt-10 font-sans text-[0.7rem] tracking-wide text-sand/40">
        Sevgiyle hazırlandı — bu güzel geceyi bizimle paylaştığınız için teşekkürler.
      </p>
    </div>
  </footer>
);
